import { matchPath, useLocation } from 'react-router';

export const useActiveStatusUpdateTemplateId = () => {
  const { pathname } = useLocation();
  const res = matchPath(pathname, {
    path: '/templates/status-updates/:templateId',
    exact: true,
  });
  const templateId = (res?.params as any)?.templateId;
  const docId = templateId !== 'new' ? parseInt(templateId, 10) : templateId;

  return docId;
};
